module.exports = __webpack_public_path__ + "img/brink_slide_3.9ae155bf.jpg";